/* ============================================================
   HARD.NOISE — Farb-Swatches (Basics / PoD)   gehört zu hn-swatches.css
   1) Shop-Übersicht: Hover/Klick auf Dot -> Vorschaubild der Farbversion
   2) Produktseite: Klick auf Farbe -> ganze Produktsektion des verknüpften
      Artikels per AJAX eintauschen (Bild/Preis/Größen/Warenkorb), URL via
      pushState. Fallback: normaler Link navigiert (Progressive Enhancement).
   Idempotent, additiv, verändert keine Vessel-Kerndatei.
   ============================================================ */
(function () {
  'use strict';

  /* ---------------- Shop-Übersicht (Karten-Dots) ---------------- */
  function initCards(scope) {
    (scope || document).querySelectorAll('[data-rpp-swatches]').forEach(function (row) {
      if (row.dataset.hnInit === '1') return;
      row.dataset.hnInit = '1';

      var card = row.closest('.rpp-card');
      if (!card) return;
      var imgA = card.querySelector('.rpp-img--a');
      var imgB = card.querySelector('.rpp-img--b'); // Hover-Bild (kann fehlen)
      var link = card.querySelector('.rpp-link');
      var meta = card.querySelector('.rpp-meta');
      if (!imgA) return;

      // ── Kugelsicherer Bild-Setter ────────────────────────────────
      // Sobald ein <img> ein srcset ODER ein umschliessendes <picture> mit
      // <source srcset> hat, waehlt der Browser laut HTML-Spec IMMER daraus
      // und ignoriert jedes spaetere src-Update dauerhaft. Deshalb muss beim
      // Farbwechsel zwingend auch srcset/<source> neutralisiert werden, sonst
      // aendert sich nur das Attribut, aber nicht das angezeigte Bild.
      // hardenImage() entfernt einmalig alle responsiven Quellen; ab da
      // steuert ausschliesslich dieses Script per img.src.
      function hardenImage(img) {
        if (!img) return;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        var pic = img.closest ? img.closest('picture') : null;
        if (pic) {
          pic.querySelectorAll('source').forEach(function (s) {
            s.removeAttribute('srcset');
            s.removeAttribute('src');
          });
        }
      }
      function setImg(img, src) {
        if (!img || !src) return;
        hardenImage(img); // idempotent -- schuetzt auch neu injizierte Quellen
        img.src = src;
      }

      hardenImage(imgA);
      hardenImage(imgB);

      // Beide Bilder setzen, weil Karten-Hover normalerweise auf img--b umschaltet
      var activeA = imgA.getAttribute('src');
      var activeB = imgB ? imgB.getAttribute('src') : null;
      var dots = Array.prototype.slice.call(row.querySelectorAll('.rpp-sw'));

      function paint(src) { setImg(imgA, src); if (imgB) setImg(imgB, src); }
      function restore() { setImg(imgA, activeA); if (imgB) setImg(imgB, activeB); }

      // Bestaetigter Klick-Wechsel: kurzer Crossfade (~180ms) statt hartem Sprung.
      var fadeTimer = null;
      function paintFade(src) {
        if (fadeTimer) clearTimeout(fadeTimer);
        imgA.classList.add('rpp-img--swapping');
        if (imgB) imgB.classList.add('rpp-img--swapping');
        fadeTimer = setTimeout(function () {
          setImg(imgA, src);
          if (imgB) setImg(imgB, src);
          imgA.classList.remove('rpp-img--swapping');
          if (imgB) imgB.classList.remove('rpp-img--swapping');
          fadeTimer = null;
        }, 170);
      }

      dots.forEach(function (dot) {
        var dImg = dot.dataset.img;
        var show = function () { if (dImg) paint(dImg); };

        dot.addEventListener('mouseenter', show);
        dot.addEventListener('focus', show);
        dot.addEventListener('mouseleave', restore);
        dot.addEventListener('blur', restore);

        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          dots.forEach(function (d) { d.classList.remove('is-active'); d.setAttribute('aria-pressed', 'false'); });
          dot.classList.add('is-active');
          dot.setAttribute('aria-pressed', 'true');
          if (dImg) { activeA = dImg; activeB = dImg; paintFade(dImg); }
          var url = dot.dataset.url;
          if (url) { if (link) link.href = url; if (meta) meta.href = url; }
        });
      });
    });
  }

  /* ---------------- Produktseite (AJAX-Farbwechsel) ---------------- */
  var prefetched = {};
  function prefetch(href) {
    if (!href || prefetched[href]) return;
    prefetched[href] = 1;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    document.head.appendChild(l);
  }

  // Vorschau-Kontext (preview_theme_id/_fd) an den Fetch/History anhängen.
  // In Produktion sind diese Parameter nicht vorhanden -> saubere URL.
  function withCtx(path) {
    try {
      var cur = new URLSearchParams(location.search);
      var keep = new URLSearchParams();
      ['preview_theme_id', '_fd'].forEach(function (k) { if (cur.has(k)) keep.set(k, cur.get(k)); });
      var s = keep.toString();
      if (!s) return path;
      return path + (path.indexOf('?') > -1 ? '&' : '?') + s;
    } catch (e) { return path; }
  }

  function swapTo(path, push) {
    var cur = document.querySelector('.product-information') || document.querySelector('[data-hn-swatches]');
    var wrapper = cur ? cur.closest('.shopify-section') : null;
    if (!wrapper) { window.location = path; return; }

    var cs = wrapper.querySelector('.hn-cs');
    if (cs) cs.classList.add('is-loading');

    fetch(withCtx(path), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('bad'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newPi = doc.querySelector('.product-information') || doc.querySelector('[data-hn-swatches]');
        var newWrapper = newPi ? newPi.closest('.shopify-section') : null;
        if (!newWrapper) { window.location = path; return; }

        wrapper.innerHTML = newWrapper.innerHTML;
        if (doc.title) document.title = doc.title;
        if (push) history.pushState({ hnSwatch: true }, '', withCtx(path));

        // Tech-Specs (hn-merch.js) + Swatches auf neuem Inhalt neu aufbauen
        wrapper.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: {} }));
        initPDP(wrapper);
      })
      .catch(function () { window.location = path; });
  }

  function initPDP(scope) {
    (scope || document).querySelectorAll('[data-hn-swatches]').forEach(function (root) {
      if (root.dataset.hnInit === '1') return;
      root.dataset.hnInit = '1';

      root.querySelectorAll('[data-hn-swatch]').forEach(function (a) {
        var href = a.getAttribute('href');
        a.addEventListener('mouseenter', function () { prefetch(href); });
        a.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return; // neuer Tab o. Ä.
          if (a.classList.contains('is-active')) { e.preventDefault(); return; }
          e.preventDefault();
          swapTo(href, true);
        });
      });
    });
  }

  window.addEventListener('popstate', function () {
    if (document.querySelector('[data-hn-swatches]')) {
      swapTo(location.pathname, false);
    }
  });

  /* ---------------- Boot ---------------- */
  function initAll(scope) { initCards(scope); initPDP(scope); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  // Theme-Editor: neu geladene Sektionen
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
})();
